import axios from "axios";
import url1 from '../../config.js'
const url=`${url1.url}/api/adminuser`;

export default class AdminUser {
    constructor(adminuser = {}) {
        this.adminUserFirstName = adminuser.adminUserFirstName || "";
        this.adminUserLastName=adminuser.adminUserLastName||"";
        this.adminUserEmail=adminuser.adminUserEmail||"",
        this.adminUserPassword=adminuser.adminUserPassword||"";
    }


    //used to send new random password to admin user in ForgotPassword page
    static getForgotPassword = async ( adminUserEmail) => {
        return  axios.get(`${url}/adminuseremail/${adminUserEmail}`);}
    
    //used to change profile of admin user on EditAdminUserProfile.vue page
    static putProfile(token,  adminUser_id, adminUser) {
        console.log('adminUser client model', adminUser);
        return axios.put(`${url}/profile/${adminUser_id}`,adminUser , {headers:{"x-auth-token":token}});
    }

    static putPassword(token,  adminUser_id, password, newPassword) {
        return axios.put(`${url}/password/${adminUser_id}`, { adminUserPassword:password, newPassword:newPassword}, {headers:{"x-auth-token":token}});
    }

    /*
    static delete(token, userid) {
        return (
            confirm("Are you sure you want to delete this admin user?") &&
            axios.delete(`${url}/${userid}`, {headers:{"x-auth-token":token}})
        );
    }*/
}